import { render, staticRenderFns } from "./crtpoints.vue?vue&type=template&id=2ffccf3a&scoped=true&"
import script from "./crtpoints.vue?vue&type=script&lang=js&"
export * from "./crtpoints.vue?vue&type=script&lang=js&"
import style1 from "./crtpoints.vue?vue&type=style&index=1&id=2ffccf3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffccf3a",
  null
  
)

export default component.exports